<kt-portlet>

	<!-- <kt-portlet-header [sticky]="true" [title]="'Machine List'" [class]="'kt-portlet__head--lg'" [viewLoading$]="dataSource.loading$"> -->

	<!-- </kt-portlet-header> -->
	<!-- end::Header -->

	<kt-portlet-body>

		<!-- start::FILTERS & GROUP ACTIONS -->
		<div class="kt-form kt-margin-b-30">
			<!-- start::FILTERS -->
			<form #sForm="ngForm" [formGroup]="searchForm" (ngSubmit)="onSubmited()" class="kt-form__filtration">
				<!-- <div class="row align-items-center">
					<div class="col-xl-4 col-md-6 col-sm-12">
						<mat-form-field>
							<mat-select formControlName="tranType" placeholder="Transaction Type" class="mat-form-field mat-form-field-fluid" required>
								<mat-option value="all">All</mat-option>
								<mat-option value="fail">Aborted</mat-option>
								<mat-option value="offline">Offline</mat-option>
								<mat-option value="pass">Success</mat-option>
								<mat-option value="passnolbl">Success(Print failed)</mat-option>
							</mat-select>
							<mat-error *ngIf="!searchForm.get('tranType').valid">Please select transaction type</mat-error>
						</mat-form-field>
					</div>
				</div> -->
				<div class="row mt-2">

					<div class="col-xl-4 col-md-6 col-sm-12">
						<mat-form-field>
							<input matInput formControlName="startDate" [matDatepicker]="pickerS" placeholder="Choose a start date" readonly required>
							<mat-datepicker-toggle matSuffix [for]="pickerS"></mat-datepicker-toggle>
							<mat-datepicker #pickerS></mat-datepicker>
							<mat-error *ngIf="!searchForm.get('startDate').valid">Please select start date</mat-error>
						</mat-form-field>
					</div>

					<!-- <div class="col-xl-1"></div> -->
					<div class="col-xl-4 col-md-6 col-sm-12">
						<mat-form-field>
							<input matInput formControlName="endDate" [matDatepicker]="pickerE" placeholder="Choose an end date" readonly required>
							<mat-datepicker-toggle matSuffix [for]="pickerE"></mat-datepicker-toggle>
							<mat-datepicker #pickerE></mat-datepicker>
							<mat-error *ngIf="!searchForm.get('endDate').valid">Please select end date</mat-error>
						  </mat-form-field>
					</div>

					<!-- <div class="col-md-6 col-sm-4"></div> -->

					<div class="col-xl-4 col-md-6 col-sm-8 d-flex align-items-center">
						<button mat-raised-button type="submit" color="primary" class="mr-4">
							<mat-icon class="mt-1">search</mat-icon>
							Search
						</button>

						<button type="button" (click)="exportExcel()" class="btn btn-success">
							Export Report
						</button>
					</div>
				</div>
			</form>
			<!-- end::FILTERS -->
		</div>
		<!-- end::FILTERS & GROUP ACTIONS -->

		<div class="mat-table__wrapper">

			<mat-table class="lmat-elevation-z8"
				#table
				[dataSource]="dataSource"matSort
				matSortActive="utc_time_stamp"
				matSortDirection="desc"
				matSortDisableClear>

				<ng-container matColumnDef="drink">
					<mat-header-cell *matHeaderCellDef>Drink</mat-header-cell>
					<mat-cell *matCellDef="let sale">{{sale.drink}}</mat-cell>
				</ng-container>

				<!-- <ng-container matColumnDef="trn_id">
					<mat-header-cell *matHeaderCellDef>Transaction Id</mat-header-cell>
					<mat-cell matTooltip="View {{sale.trn_id}} user activity" (click)="getUserActivity(sale)"
					style="text-decoration: underline;cursor: pointer;" class="text-primary cursor" *matCellDef="let sale">
					<span style="overflow: hidden; text-overflow: ellipsis;white-space:nowrap;">{{sale.trn_id}}</span>
				</mat-cell>
				</ng-container> -->

				<ng-container matColumnDef="drinkSize">
					<mat-header-cell *matHeaderCellDef>Size</mat-header-cell>
					<mat-cell *matCellDef="let sale">{{parseDrinkSize(sale.drinkSize)}}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="vendStatus">
					<mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
					<mat-cell *matCellDef="let sale">{{parseVendStatusCodes(sale.vendStatus)}}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="saleType">
					<mat-header-cell *matHeaderCellDef>Sale Type</mat-header-cell>
					<mat-cell *matCellDef="let sale">{{parseSaleType(sale.saleType, sale.payType)}}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="payType">
					<mat-header-cell *matHeaderCellDef>Pay Type</mat-header-cell>
					<mat-cell *matCellDef="let sale">{{parsePayType(sale.payType)}}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="freeVend">
					<mat-header-cell *matHeaderCellDef>Free Vend</mat-header-cell>
					<mat-cell *matCellDef="let sale">{{parseFreeVendProgress(sale)}}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="utc_time_stamp">
					<mat-header-cell *matHeaderCellDef>Date</mat-header-cell>
					<mat-cell *matCellDef="let sale">
						{{sale.utc_time_stamp | date:'MM/dd/yy hh:mm:ss a'}}
					</mat-cell>
				</ng-container>

				<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
				<mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
			</mat-table>
			<div class="mat-table__message" *ngIf="!searchForm.valid || !searchBtnClicked">Please apply filters and click search</div>
			<div class="mat-table__message" *ngIf="!(dataSource.loading$ | async) && dataSource.empty">No records found</div>
			<div class="mat-table__message" *ngIf="dataSource.loading$ | async">Please wait....</div>
		</div>


		<div class="mat-table__bottom">
			<mat-spinner [diameter]="20" *ngIf="dataSource.loading$ | async"></mat-spinner>
			<mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 50, 100]"  [showFirstLastButtons]="true"></mat-paginator>
		</div>
	</kt-portlet-body>

</kt-portlet>
